import script from "./StationBanner.vue?vue&type=script&setup=true&lang=ts"
export * from "./StationBanner.vue?vue&type=script&setup=true&lang=ts"

import "./StationBanner.vue?vue&type=style&index=0&id=544a6563&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-544a6563"]])

export default __exports__